import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import {
  criarProspecto,
  consultaEmail,
  fecharSucessoCriacaoProspecto,
} from '~/Store/Prospecto/actions';
import { Button, Modal, Form } from 'react-bootstrap';
import { Formik, useFormikContext } from 'formik';
import * as Yup from 'yup';
import _size from 'lodash/size';
import { FaSpinner, FaTag } from 'react-icons/fa';
import history from '../../Config/history';
import { default as Selector } from 'react-select';
import AuthStorage, { default as auth } from '../../Utils/AuthStorage';
import {
  TIPO_PESSOA,
  MASK_CNPJ_ALFANUMERICO,
  MASK_CPF,
  EMPREENDIMENTO_LANCAMENTO,
} from '../../constant';
import * as helpers from '../../Utils/Helpers';
import ConsultaTelefone from './ProspectoDetalhes/ConsultaTelefone';
import ConsultaCPF from './ProspectoDetalhes/ConsultaCPF';
import ConsultaEmail from './ProspectoDetalhes/ConsultaEmail';
import { toPascalCaseWithSpaces } from '~/Pages/Vendas/helpers';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';

const ModalAdicionarProspecto = ({
  location,
  empreendimentos,
  gerentesCorretores,
  criandoProspecto,
  criarProspecto,
  consultaEmail,
  erroCriandoProspecto,
  quandoCriarProspecto,
  fecharSucessoCriacaoProspecto,
}) => {
  let params = new URLSearchParams(location.search);
  const isAdm = auth.isADM();
  const isGerente = auth.isGerente();
  const isCAV = auth.isCAV();
  const isCorretor = !isAdm && !isGerente && !isCAV;
  const [primeiraRenderizacao, setPrimeiraRenderizacao] = useState(null);
  const [dadosUltimoProspectoCriado, setDadosUltimoProspectoCriado] = useState(
    null
  );

  // Estados para eventos de tag
  const [eventosTag, setEventosTag] = useState(null);
  const [adicionarTagEvento, setAdicionarTagEvento] = useState(false);
  const [vinculandoTag, setVinculandoTag] = useState(false);
  const [midias, setMidias] = useState([]);
  const [segundoProponenteInfo, setSegundoProponenteInfo] = useState(null);
  const [
    direcionarParaCorretorOriginal,
    setDirecionarParaCorretorOriginal,
  ] = useState(false);
  const DIAS_VERIFICACAO_SEGUNDO_PROPONENTE = 30;

  let initialValues = {
    tipo_pessoa: '0',
    nome: '',
    nome_social: '',
    email: '',
    tel_celular: '',
    tel_residencial: '',
    tel_comercial: '',
    codigo_familia: '',
    codigo_corretor: '',
    codigo_gerente: '',
    cpf: '',
    midia_origem: '',
    codigo_nacionalidade: 1,
    is_documento_cin: '0',
  };

  const codigoUsuario = auth.getUser().usuario;
  if (isCorretor && gerentesCorretores.listaGerentes.length > 1) {
    initialValues.codigo_corretor = codigoUsuario;
    initialValues.codigo_gerente =
      gerentesCorretores.corretoresById[codigoUsuario].codigo_gerente;
  } else if (isGerente) {
    initialValues.codigo_gerente = codigoUsuario;
  }

  // Função para buscar eventos de tag
  const buscarEventosTagPorEmpreendimento = async codigoFamilia => {
    if (!codigoFamilia) {
      setEventosTag(null);
      setAdicionarTagEvento(false);
      return;
    }

    try {
      const response = await api.buscarEventosTag(codigoFamilia);
      if (response && response.ativo && response.codigo_tag) {
        setEventosTag(response);
        setAdicionarTagEvento(true);
      } else {
        setEventosTag(null);
        setAdicionarTagEvento(false);
      }
    } catch (error) {
      console.error('Erro ao buscar eventos de tag:', error);
      setEventosTag(null);
      setAdicionarTagEvento(false);
    }
  };

  // Função para vincular a tag após criar o prospecto
  const vincularTagEvento = async (codigoProspecto, codigoFamilia) => {
    if (!eventosTag || !adicionarTagEvento) return;

    try {
      setVinculandoTag(true);
      const response = await api.vincularTag({
        codigo_familia: codigoFamilia,
        codigo_prospecto: codigoProspecto,
        codigo_tag: eventosTag.codigo_tag,
      });

      if (response) {
        toast.success(`Tag "${eventosTag.nome_tag}" vinculada com sucesso!`);
      }
    } catch (error) {
      toast.error('Erro ao vincular tag do evento');
      console.error('Erro ao vincular tag:', error);
    } finally {
      setVinculandoTag(false);
    }
  };

  const verificarSegundoProponenteEAtualizar = async (
    codigoFamilia,
    cpf,
    tipoPessoa
  ) => {
    const cpfFormatado = helpers.format.cpf(cpf);
    if (tipoPessoa !== '0' || !cpfFormatado || cpfFormatado.length !== 14) {
      setSegundoProponenteInfo(null);
      setDirecionarParaCorretorOriginal(false);
      return;
    }
    try {
      const segundoProponente = await api.verificarSegundoProponente({
        codigo_familia: codigoFamilia || 0,
        cpf: cpfFormatado,
      });
      if (segundoProponente && segundoProponente.codigo_corretor != 0) {
        setSegundoProponenteInfo(segundoProponente);
        const ultima = segundoProponente.ultima_movimentacao
          ? new Date(segundoProponente.ultima_movimentacao)
          : null;
        const diasSemMovimento = ultima
          ? Math.floor((Date.now() - ultima.getTime()) / 86400000)
          : Infinity;
        const deveDirecionar =
          diasSemMovimento <= DIAS_VERIFICACAO_SEGUNDO_PROPONENTE;
        setDirecionarParaCorretorOriginal(deveDirecionar);
      } else {
        setSegundoProponenteInfo(null);
        setDirecionarParaCorretorOriginal(false);
      }
    } catch (err) {
      setSegundoProponenteInfo(null);
      setDirecionarParaCorretorOriginal(false);
    }
  };

  const SelectComponent = () => {
    const { setFieldValue, values } = useFormikContext();
    useEffect(() => {
      if (primeiraRenderizacao != null) return;
      setPrimeiraRenderizacao(true);

      const empreendimento = EMPREENDIMENTO_LANCAMENTO
        ? optionsEmpreendimento.find(
            option => option.value === EMPREENDIMENTO_LANCAMENTO
          )
        : null;
      if (!empreendimento) {
        setIsDisabledLancamento(false);
      }

      if (empreendimento && !values.codigo_familia) {
        setFieldValue('codigo_familia', empreendimento && empreendimento.value);
        // Buscar eventos de tag para o empreendimento pré-selecionado
        buscarEventosTagPorEmpreendimento(empreendimento.value);
      }
      if (
        EMPREENDIMENTO_LANCAMENTO &&
        empreendimento &&
        empreendimento.value === EMPREENDIMENTO_LANCAMENTO &&
        !isCorretor
      ) {
        setFieldValue('codigo_corretor', 1078);
        setFieldValue('codigo_gerente', 1077);
      }
      if (
        EMPREENDIMENTO_LANCAMENTO &&
        empreendimento &&
        empreendimento.value === EMPREENDIMENTO_LANCAMENTO &&
        !isAtendenteLancamento &&
        !isCorretor
      ) {
        setIsDisabledLancamento(true);
      } else {
        setIsDisabledLancamento(false);
      }
    }, [primeiraRenderizacao]);

    return (
      <>
        <Selector
          isLoading={
            optionsEmpreendimento && optionsEmpreendimento.length === 0
          }
          isDisabled={
            optionsEmpreendimento && optionsEmpreendimento.length === 0
          }
          styles={customStyles}
          components={{ DropdownIndicator }}
          value={
            values.codigo_familia
              ? optionsEmpreendimento.find(
                  option => option.value === values.codigo_familia
                )
              : null
          }
          noOptionsMessage={() => 'Nenhum empreendimento encontrado'}
          placeholder="Pesquisar empreendimentos..."
          options={optionsEmpreendimento}
          onChange={async option => {
            setFieldValue('codigo_familia', option.value);

            // Buscar eventos de tag quando selecionar empreendimento manualmente
            buscarEventosTagPorEmpreendimento(option.value);

            await verificarSegundoProponenteEAtualizar(
              option.value,
              values.cpf,
              values.tipo_pessoa
            );

            if (
              EMPREENDIMENTO_LANCAMENTO &&
              option.value === EMPREENDIMENTO_LANCAMENTO &&
              !isAtendenteLancamento &&
              !isCorretor
            ) {
              setFieldValue('codigo_corretor', 1078);
              setFieldValue('codigo_gerente', 1077);
              setIsDisabledLancamento(true);
            } else {
              setIsDisabledLancamento(false);
            }
          }}
          disabled={criandoProspecto}
        />
      </>
    );
  };

  const validationSchema = Yup.object().shape({
    tipo_pessoa: Yup.string().required('Selecione o tipo de pessoa'),
    midia_origem: Yup.string().required('Selecione a mídia origem'),
    nome: Yup.string().when('tipo_pessoa', {
      is: 0,
      then: schema =>
        schema
          .required('Informe o nome')
          .matches(/^[^\d]*$/, 'O nome não pode conter números'),
      otherwise: schema => schema.required('Informe o nome'),
    }),
    tel_celular: Yup.string().matches(
      /^(?:\(\d{2}\)\s?)?9\d{4}-\d{4}$/,
      'Número de celular inválido'
    ),
    tel_residencial: Yup.string().test(
      'tel-residencial-valido',
      'Número de telefone residencial inválido',
      function(value) {
        if (!value) return true;
        const apenasNumeros = value.replace(/\D/g, '');
        if (apenasNumeros.length === 10) {
          value = helpers.format.celular(value || '');
          return /^(?:\(\d{2}\)\s?)?\d{4}-\d{4}$/.test(value);
        } else if (apenasNumeros.length === 11) {
          value = helpers.format.celular(value || '');
          return /^(?:\(\d{2}\)\s?)?\d{5}-\d{4}$/.test(value);
        }
        return false;
      }
    ),
    tel_comercial: Yup.string().test(
      'tel-comercial-valido',
      'Número de telefone comercial inválido',
      function(value) {
        if (!value) return true;
        const apenasNumeros = value.replace(/\D/g, '');
        if (apenasNumeros.length === 10) {
          value = helpers.format.celular(value || '');
          return /^(?:\(\d{2}\)\s?)?\d{4}-\d{4}$/.test(value);
        } else if (apenasNumeros.length === 11) {
          value = helpers.format.celular(value || '');
          return /^(?:\(\d{2}\)\s?)?\d{5}-\d{4}$/.test(value);
        }
        return false;
      }
    ),
    email: Yup.string()
      .email('Informe um email válido')
      .matches(
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
        'Informe um email no formato válido'
      ),
    cpf: Yup.string().when(['tipo_pessoa', 'is_documento_cin'], {
      is: (tipo_pessoa, is_documento_cin) =>
        is_documento_cin &&
        tipo_pessoa === '0' &&
        is_documento_cin.toString() === '1',
      then: Yup.string().required('O campo CIN é obrigatório'),
      otherwise: Yup.string(),
    }),
  });

  const validate = values => {
    let errors = {};
    if (!values.email && !values.tel_celular) {
      errors.email = 'Informe ao menos um contato';
      errors.tel_celular = 'Informe ao menos um contato';
    }
    return errors;
  };

  const optionsEmpreendimento = empreendimentos.sort.map(item => {
    return {
      value: item.codigo,
      label: item.descricao,
    };
  });

  const optionsMidias = midias.sort().map(item => {
    return {
      value: item.codigo,
      label: item.cfsd_descricao,
    };
  });

  const [isDisabledLancamento, setIsDisabledLancamento] = useState(false);
  const isAtendenteLancamento = auth.isAtendenteLancamento();
  const emailVerifyTimeoutRef = useRef(null);

  useEffect(() => {
    const buscarMidias = async () => {
      try {
        const midias = await api.getMidias();
        if (midias) {
          setMidias(midias);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarMidias();
  }, []);

  const buildValueEmpreendimento = CodigoFamilia => {
    return CodigoFamilia
      ? {
          value: parseInt(empreendimentos.byId[CodigoFamilia].codigo),
          label: empreendimentos.byId[CodigoFamilia].descricao,
        }
      : { value: '', label: 'Selecione um empreendimento' };
  };

  const limparEstadosDoModal = resetForm => {
    resetForm({ values: { ...initialValues } });
    setPrimeiraRenderizacao(null);
    setEventosTag(null);
    setAdicionarTagEvento(false);
    setSegundoProponenteInfo(null);
    setDirecionarParaCorretorOriginal(false);
  };

  const fecharModalSucesso = () => {
    setDadosUltimoProspectoCriado(null);
  };

  const abrirCadastroProspecto = codigoProspecto => {
    fecharSucessoCriacaoProspecto();
    fecharModalSucesso();
    history.push(`/prospectos/lista/${codigoProspecto}`);
  };

  const abrirModalSucesso = (codigoProspecto, nomeProspecto) => {
    setDadosUltimoProspectoCriado({
      codigo: codigoProspecto,
      nome: nomeProspecto,
    });
  };

  const salvarProspecto = async (values, { resetForm }) => {
    try {
      let payload = { ...values };

      if (segundoProponenteInfo && direcionarParaCorretorOriginal) {
        payload.codigo_corretor = segundoProponenteInfo.codigo_corretor;
        toast.warn(
          `Cadastro direcionado ao corretor original: ${segundoProponenteInfo.nome_corretor}`
        );
      }
      let codigo = 0;
      ({ codigo } = await criarProspecto(payload));

      if (codigo && adicionarTagEvento && eventosTag) {
        await vincularTagEvento(codigo, values.codigo_familia);
      }
      if (codigo) {
        limparEstadosDoModal(resetForm);
        abrirModalSucesso(codigo, values.nome);
      }
      if (codigo && quandoCriarProspecto) {
        try {
          await quandoCriarProspecto(codigo);
        } catch (errorAtualizacao) {
          toast.error(
            errorAtualizacao && errorAtualizacao.message
              ? errorAtualizacao.message
              : 'Prospecto criado, mas nao foi possivel atualizar a listagem.'
          );
        }
      }
    } catch (error) {
      toast.error(
        error && error.message ? error.message : 'Erro ao criar usuário'
      );
    }
  };

  if (!params.get('novo')) {
    return null;
  }

  return (
    <Formik
      enableReinitialize={true}
      validate={validate}
      initialValues={initialValues}
      onSubmit={salvarProspecto}
      validationSchema={validationSchema}
    >
      {({
        setFieldValue,
        values,
        handleChange,
        handleBlur,
        errors,
        touched,
        submitCount,
        handleSubmit,
        setTouched,
      }) => {
        return (
          <React.Fragment>
            <Modal
              backdrop="static"
              show={true}
              onHide={() => {
                fecharModalSucesso();
                history.push({ search: '' });
                setPrimeiraRenderizacao(null);
                setEventosTag(null);
                setAdicionarTagEvento(false);
              }}
            >
              <Modal.Header>
                <Modal.Title>Novo Cliente</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <>
                    <Form.Group controlId="prospecto.codigo_familia">
                      <Form.Label srOnly>Selecione um empreendimento</Form.Label>
                      <SelectComponent />
                    </Form.Group>

                    {eventosTag && eventosTag.ativo && (
                      <div
                        className="mb-3 p-3 border rounded"
                        style={{ backgroundColor: '#f8f9ff' }}
                      >
                        <div className="d-flex align-items-start">
                          <Form.Check
                            type="checkbox"
                            id="checkbox-tag-evento"
                            checked={adicionarTagEvento}
                            onChange={e =>
                              setAdicionarTagEvento(e.target.checked)
                            }
                            disabled={criandoProspecto || vinculandoTag}
                            className="mr-2 mt-1"
                          />
                          <div className="flex-grow-1">
                            <label
                              htmlFor="checkbox-tag-evento"
                              style={{
                                cursor: 'pointer',
                                fontWeight: 600,
                                marginBottom: 4,
                              }}
                            >
                              <FaTag
                                className="mr-2"
                                style={{ color: '#2196f3' }}
                              />
                              Adicionar TAG do evento?
                            </label>
                            <div
                              style={{ fontSize: '0.875rem', color: '#6c757d' }}
                            >
                              Evento: <strong>{eventosTag.nome_evento}</strong>
                              <br />
                              Tag:{' '}
                              <span
                                style={{
                                  background: '#2196f3',
                                  color: '#fff',
                                  borderRadius: 10,
                                  padding: '2px 8px',
                                  fontSize: '0.75rem',
                                  marginLeft: 4,
                                }}
                              >
                                {eventosTag.nome_tag}
                              </span>
                              <br />
                              Período:{' '}
                              {helpers.format.date(
                                eventosTag.data_inicial,
                                'DD/MM/YYYY'
                              )}{' '}
                              até{' '}
                              {helpers.format.date(
                                eventosTag.data_final,
                                'DD/MM/YYYY'
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>

                  <React.Fragment>
                  <Form.Group controlId="values.tipo_pessoa">
                    <Form.Label>Tipo do Cadastro</Form.Label>
                    <Form.Control
                      as="select"
                      name="tipo_pessoa"
                      onChange={e => {
                        handleChange(e);
                        if (e.target.value !== '0') {
                          setFieldValue('is_documento_cin', '0');
                        }
                      }}
                      value={values.tipo_pessoa}
                      onBlur={handleBlur}
                      isInvalid={errors.tipo_pessoa && touched.tipo_pessoa}
                      disabled={criandoProspecto}
                    >
                      {TIPO_PESSOA.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.tipo_pessoa}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="midia_origem">
                    <Form.Label>Mídia Origem</Form.Label>
                    <div
                      className={
                        errors.midia_origem && touched.midia_origem
                          ? 'is-invalid'
                          : ''
                      }
                    >
                      <Selector
                        isLoading={optionsMidias.length === 0}
                        isDisabled={optionsMidias.length === 0}
                        noOptionsMessage={() => 'Nenhum mídia encontrada.'}
                        placeholder="Selecione a mídia de origem..."
                        options={optionsMidias}
                        onChange={selectedOptions => {
                          setFieldValue(
                            'midia_origem',
                            selectedOptions ? selectedOptions.value : ''
                          );
                        }}
                        onBlur={() =>
                          setTouched({ ...touched, midia_origem: true })
                        }
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        isClearable={true}
                      />
                    </div>
                    <Form.Control.Feedback
                      type="invalid"
                      className={
                        errors.midia_origem && touched.midia_origem
                          ? 'd-block'
                          : ''
                      }
                    >
                      {errors.midia_origem}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group controlId="values.is_documento_cin">
                    <Form.Label>Usar documento CIN?</Form.Label>
                    <Selector
                      name="is_documento_cin"
                      value={{
                        value: values.is_documento_cin,
                        label:
                          values.is_documento_cin.toString() === '1'
                            ? 'Sim'
                            : 'Não',
                      }}
                      options={[
                        { value: '0', label: 'Não' },
                        { value: '1', label: 'Sim' },
                      ]}
                      onChange={option =>
                        setFieldValue('is_documento_cin', option.value)
                      }
                      isDisabled={
                        criandoProspecto || values.tipo_pessoa === '1'
                      }
                      placeholder="Selecione..."
                    />
                  </Form.Group>
                  <Form.Group controlId="values.cpf">
                    <Form.Label>
                      {values.tipo_pessoa === '0' ? 'CPF/CIN' : 'CNPJ'}
                    </Form.Label>

                    <ConsultaCPF
                      onChangeCPF={handleChange}
                      ignore={false}
                      values={values}
                    >
                      {({ onChangeCPF, consultandoCPF }) => (
                        <>
                          <MaskedInput
                            type={
                              values.tipo_pessoa === '0' ? 'tel' : 'text'
                            }
                            name="cpf"
                            className={`form-control ${errors.cpf &&
                              touched.cpf &&
                              'is-invalid'}`}
                            onChange={async e => {
                              onChangeCPF(e);
                              await verificarSegundoProponenteEAtualizar(
                                values.codigo_familia || 0,
                                e.currentTarget.value,
                                values.tipo_pessoa
                              );
                            }}
                            onBlur={handleBlur}
                            value={helpers.format.cpf(values.cpf)}
                            placeholder={
                              values.tipo_pessoa === '0'
                                ? 'Ex.: 000.000.000-00'
                                : 'Ex.: 00.000.000/0000-00'
                            }
                            mask={
                              values.tipo_pessoa === '0'
                                ? MASK_CPF
                                : MASK_CNPJ_ALFANUMERICO
                            }
                            disabled={criandoProspecto || consultandoCPF}
                          />
                        </>
                      )}
                    </ConsultaCPF>
                    {errors.cpf && touched.cpf && (
                      <small className="form-text text-danger">
                        {errors.cpf}
                      </small>
                    )}
                    {segundoProponenteInfo &&
                      direcionarParaCorretorOriginal && (
                        <div className="alert alert-warning mt-2">
                          CPF já existe como segundo proponente em lead recente.
                          Ao salvar, o cadastro será direcionado para o corretor
                          original {segundoProponenteInfo.nome_corretor}.
                        </div>
                      )}
                  </Form.Group>
                  <Form.Group controlId="values.nome">
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      type="text"
                      name="nome"
                      maxLength="100"
                      onChange={e => {
                        setFieldValue(
                          'nome',
                          toPascalCaseWithSpaces(e.target.value)
                        );
                      }}
                      onBlur={handleBlur}
                      value={values.nome}
                      isInvalid={errors.nome && touched.nome}
                      placeholder="Nome do cliente"
                      disabled={criandoProspecto}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.nome}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.nome_social">
                    <Form.Label>Nome Social</Form.Label>
                    <Form.Control
                      type="text"
                      name="nome_social"
                      maxLength="60"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nome_social}
                      placeholder="Nome social do cliente"
                      disabled={criandoProspecto}
                    />
                  </Form.Group>
                  <Form.Group controlId="values.email">
                    <Form.Label>Email</Form.Label>
                    <ConsultaEmail
                      onChangeEmail={handleChange}
                      ignore={true}
                      values={values}
                    >
                      {({ onChangeEmail, consultandoEmail }) => (
                        <Form.Control
                          type="text"
                          name="email"
                          maxLength="60"
                          onChange={onChangeEmail}
                          onBlur={e => {
                            handleBlur(e);
                            const value = e.target.value;
                            const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
                            if (!value || !regex.test(value)) return;
                            if (emailVerifyTimeoutRef.current) {
                              clearTimeout(emailVerifyTimeoutRef.current);
                            }
                            emailVerifyTimeoutRef.current = setTimeout(() => {
                              consultaEmail(value);
                            }, 300);
                          }}
                          value={values.email}
                          isInvalid={errors.email && touched.email}
                          placeholder="email@dominio.com.br"
                          disabled={criandoProspecto || consultandoEmail}
                        />
                      )}
                    </ConsultaEmail>

                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.tel_celular">
                    <Form.Label>Celular</Form.Label>
                    <ConsultaTelefone
                      onChangeTelefone={handleChange}
                      ignore={false}
                      values={values}
                    >
                      {({ onChangeTelefone, consultandoTelefone }) => (
                        <MaskedInput
                          type="cel"
                          className={`form-control ${errors.tel_celular &&
                            touched.tel_celular &&
                            'is-invalid'}`}
                          name="tel_celular"
                          onChange={onChangeTelefone}
                          onBlur={handleBlur}
                          value={values.tel_celular}
                          mask={helpers.mask.celular}
                          placeholder="(00) 00000-0000"
                          disabled={criandoProspecto || consultandoTelefone}
                        />
                      )}
                    </ConsultaTelefone>
                    <Form.Control.Feedback type="invalid">
                      {errors.tel_celular}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.tel_residencial">
                    <Form.Label>Telefone residencial</Form.Label>
                    <MaskedInput
                      guide={false}
                      showMask={false}
                      type="cel"
                      className={`form-control ${errors.tel_residencial &&
                        touched.tel_residencial &&
                        'is-invalid'}`}
                      name="tel_residencial"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.tel_residencial}
                      mask={helpers.mask.celular}
                      placeholder="(00) 0000-0000"
                      disabled={criandoProspecto}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.tel_residencial}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.tel_comercial">
                    <Form.Label>Telefone comercial</Form.Label>
                    <MaskedInput
                      guide={false}
                      showMask={false}
                      type="tel"
                      className={`form-control ${errors.tel_comercial &&
                        touched.tel_comercial &&
                        'is-invalid'}`}
                      name="tel_comercial"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.tel_comercial}
                      mask={helpers.mask.celular}
                      placeholder="(00) 0000-0000"
                      disabled={criandoProspecto}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.tel_comercial}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.codigo_familia">
                    <Form.Label>Renda Familiar</Form.Label>
                    <MaskedInput
                      guide={false}
                      showMask={true}
                      type="text"
                      name="renda_familiar"
                      maxLength={17}
                      onChange={handleChange}
                      placeholder="R$ 0.000,00"
                      onBlur={handleBlur}
                      value={values.renda_familiar}
                      className={`form-control ${errors.renda_familiar &&
                        touched.renda_familiar &&
                        'is-invalid'}`}
                      disabled={criandoProspecto}
                      mask={helpers.mask.monetario}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.renda_familiar}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="values.codigo_familia">
                    <Form.Label>Renda Pessoal</Form.Label>
                    <MaskedInput
                      guide={false}
                      showMask={true}
                      type="text"
                      name="renda_pessoal"
                      maxLength={17}
                      onChange={handleChange}
                      placeholder="R$ 0.000,00"
                      onBlur={handleBlur}
                      value={values.renda_pessoal}
                      className={`form-control ${errors.renda_pessoal &&
                        touched.renda_pessoal &&
                        'is-invalid'}`}
                      disabled={criandoProspecto}
                      mask={helpers.mask.monetario}
                    />
                  </Form.Group>
                  </React.Fragment>

                  {submitCount > 0 &&
                    _size(errors) > 0 &&
                    _size(touched) > 0 && (
                      <div className="FormDadosPessoais__error text-danger">
                        Preenchas os campos corretamente antes de salvar
                      </div>
                    )}
                  {erroCriandoProspecto && (
                    <div className="FormDadosPessoais__error text-danger">
                      {erroCriandoProspecto}
                    </div>
                  )}
                  <div className="d-flex d-sm-block text-right justify-content-between">
                    <Button
                      variant="link"
                      className="text-uppercase px-4 d-block d-sm-inline-block"
                      onClick={() => {
                        history.push({ search: '' });
                        setEventosTag(null);
                        setAdicionarTagEvento(false);
                      }}
                      disabled={criandoProspecto || vinculandoTag}
                    >
                      Cancelar
                    </Button>
                    {!isGerente && (
                      <Button
                        variant="primary"
                        type="submit"
                        className="text-uppercase px-4 d-block d-sm-inline-block"
                        disabled={
                          criandoProspecto ||
                          vinculandoTag ||
                          (AuthStorage.isCorretor() &&
                            values.codigo_familia === '')
                        }
                      >
                        {criandoProspecto || vinculandoTag ? (
                          <span>
                            <FaSpinner />{' '}
                            {vinculandoTag ? 'Vinculando tag...' : 'Salvando...'}
                          </span>
                        ) : (
                          'Prosseguir'
                        )}
                      </Button>
                    )}
                  </div>
                </Form>
              </Modal.Body>
            </Modal>

            <Modal
              centered
              show={!!dadosUltimoProspectoCriado}
              onHide={fecharModalSucesso}
            >
              <Modal.Header
                closeButton
                style={{
                  borderBottom: 'none',
                  paddingBottom: 0,
                }}
              >
                <Modal.Title
                  style={{
                    fontWeight: 700,
                    fontSize: 22,
                    color: '#1f2937',
                  }}
                >
                  Lead cadastrado
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  paddingTop: 12,
                  paddingBottom: 12,
                }}
              >
                <div
                  style={{
                    background:
                      'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
                    border: '1px solid #e5e7eb',
                    borderRadius: 12,
                    padding: 20,
                  }}
                >
                  <div
                    style={{
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#111827',
                      lineHeight: 1.5,
                    }}
                  >
                    {dadosUltimoProspectoCriado && dadosUltimoProspectoCriado.codigo} - {dadosUltimoProspectoCriado && dadosUltimoProspectoCriado.nome} 
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer
                style={{
                  borderTop: 'none',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    abrirCadastroProspecto(
                      dadosUltimoProspectoCriado &&
                        dadosUltimoProspectoCriado.codigo
                    )
                  }
                >
                  Ver detalhes do Lead
                </Button>
                <Button variant="primary" onClick={fecharModalSucesso}>
                  Cadastrar Novo Lead
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      criarProspecto,
      consultaEmail,
      fecharSucessoCriacaoProspecto,
    },
    dispatch
  );

const mapStateToProps = state => ({
  empreendimentos: state.empreendimentos,
  gerentesCorretores: state.corretor,
  criandoProspecto: state.prospecto.criandoProspecto,
  erroCriandoProspecto: state.prospecto.erroCriandoProspecto,
  liberarCadastroProspecto: state.options.liberarCadastroProspecto,
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ModalAdicionarProspecto)
);
